module.exports = __webpack_public_path__ + "static/img/patient_encounter.fde8876.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/patient_encounter.jpg
// module id = rex4
// module chunks = 0